import { createContext, ReactNode, useContext } from 'react';
import { useIsAddressVerificationEnabled } from './useIsAddressVerificationEnabled';
import { useVenueAddressVerification } from './useVenueAddressVerification';

type VenueAddressVerification = ReturnType<typeof useVenueAddressVerification>;

const context = createContext<VenueAddressVerification | null>(null);

interface VenueAddressVerificationProviderProps {
  name: string;
  verifiedAddress: string;
  onVerify: (address: string) => void;
  children: ReactNode;
}

export function VenueAddressVerificationProvider({
  name,
  verifiedAddress,
  onVerify,
  children,
}: VenueAddressVerificationProviderProps) {
  const isEnabled = useIsAddressVerificationEnabled();
  const value = useVenueAddressVerification({
    name,
    verifiedAddress,
    onVerify,
    isEnabled,
  });

  return <context.Provider value={value}>{children}</context.Provider>;
}

export function useVenueAddressVerificationContext(): VenueAddressVerification {
  const value = useContext(context);

  if (!value) {
    throw new Error(
      'useVenueAddressVerificationContext must be used within VenueAddressVerificationProvider',
    );
  }

  return value;
}
